
const linkUnderlineStyle = {
  minHeight: 'initial',
  textDecoration: 'underline',
  textUnderlineOffset: '.3em',
  width: 'initial',
  padding: 0,
  height: 'initial',
}


export const ButtonTheme = {
  baseStyle: {
    borderRadius: 0,
    transition: '"background" .25s ease-in-out',
    _hover: {
      opacity: .8
    }
  },

  variants: {
    primary: {
      color: 'brand.white',
      background: 'linear-gradient(270deg, var(--chakra-colors-brand-gradientBlueLight) 0%, var(--chakra-colors-brand-gradientBlueDark) 100%) 0% 0%',
    },
    secondary: {
      color: 'brand.white',
      background: 'linear-gradient(90deg, #ED9A33 0%, #EEA02E 10%, #F0A629 20%, #F1AD24 30%, #F3B31F 40%, #F5BA19 50%, #F7C014 60%, #F8C70F 70%, #FACD0A 80%, #FCD405 90%, #FDDB00 100%) 0% 0% no-repeat padding-box',
    },
    white: {
      background: 'linear-gradient(91deg, var(--chakra-colors-brand-white) 0%, var(--chakra-colors-brand-fontColorWhite) 100%) 0% 0% no-repeat padding-box',
      boxShadow: 'var(--chakra-colors-brand-blueShadow)',
    },
    linkUnderline: { ...linkUnderlineStyle },
    linkUnderlinePrimary: {
      ...linkUnderlineStyle,
      textDecorationColor: 'brand.cyan'
    }
  }
}